import React, { useState } from 'react'
import styles from './StickyDisclaimer.module.scss'
import { RichTextType } from '~types'
import { Paragraph } from '~elements'
import { useWindowSize } from 'utils/hooks'
import CloseThick from '/public/assets/svg/close-thick.svg'

interface StickyDisclaimerProps {
  copy: RichTextType
}

const StickyDisclaimer = ({ copy }: StickyDisclaimerProps) => {
  const [visible, setVisible] = useState(true)
  const { isBreakpoint: isBelowMd } = useWindowSize('sm', '<')
  const closeDisclaimer = () => setVisible(false)

  return (
    <>
      {visible && copy && (
        <div className={styles['sticky-disclaimer-container']}>
          <div className={styles['sticky-disclaimer']}>
            <div className={styles['sticky-disclaimer__text']}>
              <Paragraph text={copy} fontSize={isBelowMd ? 'xxs' : 'xs'} color='gray' noMarginBottom />
            </div>
            <button
              className={styles['sticky-disclaimer__close']}
              onClick={closeDisclaimer}
              aria-label='Close disclaimer'
            >
              <CloseThick />
            </button>
          </div>
        </div>
      )}
    </>
  )
}

export default StickyDisclaimer
